/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CLandingpageColorKey {
    BRAND_COLOR = 'BrandColor',
    ACCENT_COLOR = 'AccentColor',
}
